(function () {
  const grid = document.getElementById("product-grid");
  if (!grid) return;
  const qtyOf = (card) => Number(card.dataset.qty) || 1;
  const setQty = (card, n) => {
    card.dataset.qty = n;
    card.querySelector(".qty-step .n").textContent = n;
    const addBtn = card.querySelector(".add-btn");
    addBtn.textContent = `Add · $${(Number(addBtn.dataset.price) * n).toFixed(0)}`;
  };

  grid.addEventListener("click", async (e) => {
    const card = e.target.closest(".product");
    if (!card) return;
    if (e.target.closest(".q-dec")) return setQty(card, Math.max(1, qtyOf(card) - 1));
    if (e.target.closest(".q-inc")) return setQty(card, Math.min(20, qtyOf(card) + 1));
    const addBtn = e.target.closest(".add-btn");
    if (!addBtn) return;
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    card.querySelector(".add-err").hidden = true;
    const qty = qtyOf(card);
    try {
      await MiniCart.addItems([{ id: Number(addBtn.dataset.variantId), quantity: qty }]);
      await MiniCart.refreshCount();
      addBtn.classList.add("added");
      addBtn.textContent = `✓ Added ×${qty}`;
      card.querySelector(".view-cart").hidden = false;
      setTimeout(() => { addBtn.classList.remove("added"); setQty(card, qtyOf(card)); addBtn.disabled = false; }, 1300);
    } catch (err) {
      const msg = card.querySelector(".add-err");
      msg.textContent = err.message;
      msg.hidden = false;
      setQty(card, qty);
      addBtn.disabled = false;
    }
  });
})();
